<template>
        <vx-card style="height: 325px">
            
            <div class="vx-card__title mb-4">
                <h6 class="text-center mt-3 truncate" :class="isCardInvite ? 'text-success' : 'text-danger'" v-if="data.name.length >= 24">{{ data.name.slice(0, 44) }}</h6>
                <h5 class="text-center mt-3 truncate" :class="isCardInvite ? 'text-success' : 'text-danger'" v-if="data.name.length < 24 && data.name.length >= 13">{{ data.name }}</h5>
                <h4 class="text-center mt-3 truncate" :class="isCardInvite ? 'text-success' : 'text-danger'" v-if="data.name.length < 13">{{ data.name }}</h4>
                <p class="text-center" v-if="!isCardInvite">{{ roleName(data.role) }}</p>
                <p class="text-center" v-if="isCardInvite">CONVITE</p>
            </div>

            <img :src="data.logo || noPhoto" alt="" class="mx-auto mb-2" width="150">

            <div>
                <vs-button color="danger" type="relief" class="w-full mt-4" @click="selectCompany(data.id)" v-if="!isCardInvite">ENTRAR</vs-button>
                <vs-button color="success" type="relief" class="w-full mt-4 truncate" @click="acceptInvite(data.id)" v-if="isCardInvite">ACEITAR CONVITE</vs-button>
            </div>
        </vx-card>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import AvailableRoles from '@/components/role/roles.js'
    import { removeUserTrashFields } from '@/views/pages/invite/Invitation.js'
    import { changeTawkCompany } from '@/globalComponents.js'

    export default {
        props : {
            data : {
                type: Object,
                required : false
            },
            isCardInvite : {
                type: Boolean,
                required : false
            },
            default : {
                type : Boolean,
                required : false,
            }
        },

        data () {
            return {
                ref : firebase.firestore(),
                noPhoto: 'https://firebasestorage.googleapis.com/v0/b/pedido-rapido-app.appspot.com/o/companies%2Fphotos%2Fno-photo.png?alt=media&token=5b909023-6a20-4188-9d6e-a30ea0c5f6de'
            }
        },

        mounted () {
            if(this.default) {
                this.selectCompany(this.data.id)
            }
        },

        methods : {
            roleName (roleId) {
                return AvailableRoles.getRoleName(roleId)
            },

            async acceptInvite (companyId) {
                let batch = firebase.firestore().batch()
                let ref = firebase.firestore().collection('company').doc(companyId).collection('employeeRequests').doc(this.data.invitationId)
                batch.update(ref, { active: false, accepted: true })
                
                let user = await removeUserTrashFields(this.$store.state.AppActiveUser)
                user.role = this.data.role

                ref = firebase.firestore().collection('company').doc(companyId).collection('companyUsers').doc(user.uid)
                batch.set(ref, user)

                await batch.commit()
                this.selectCompany(companyId)
            },

            async selectCompany (companyId) {
                try {
                    const userInfo = this.$store.getters.getUserStoredData
                    let userId = userInfo.uid
                    this.$vs.loading()
                    let user = await this.ref.collection('company').doc(companyId).collection('companyUsers').doc(userId).get()

                    // UPDATE LAST LOGIN
                    await this.ref.collection(`/company/${companyId}/companyUsers`).doc(userId)
                        .update({ lastLoginAt : new Date() }, { merge : true })

                    changeTawkCompany(userInfo, companyId)

                    this.$store.dispatch('updateUserInfo', user.data())
                    this.$store.dispatch('updateCompanyId', companyId)
                    this.$store.dispatch('updateCompanyInfo', this.data)
                    this.$store.commit('productType/setEmptyProductType')

                    localStorage.setItem('preferedCompany', companyId);
                    this.$router.push('/bills/opened')        
                } catch (err) {
                    this.$vs.dialog({
                        type: 'alert',
                        title: 'Erro',
                        text: `Erro ao processar a requisição: ${err.message}`,
                        acceptText: 'Fechar'
                    })
                } finally {
                    this.$vs.loading.close()
                }
                
            },
        }
    }
</script>